<template>
  <main :class='{mobile: mobileView}'v-cloak>
    <topBar :mobileView="mobileView" @showHideSide="showHideSide"/>

    <sidebar :waveformsArray="waveformsArray" :currentView="currentView" :mobileView="mobileView" @showHideSide="showHideSide" @changeView="updateView" v-if='!mobileView || sideBarToggle'/>

    <liveCallMod v-if="!sideBarToggle" :liveCallMobile='mobileView' :isCallCenter='NotcallCenterAccount' @blocked="addBlockedNumber($event)"/>

    <featureContainer v-if='!mobileView' :isCallCenter='NotcallCenterAccount' :hProduct='hProduct'/>
  </main>
</template>

<script>
import Vue from 'vue'
import topBar from '@/components/topBar'
import sidebar from '@/components/Sidebar'
import featureContainer from '@/components/featureContainer'
import liveCallMod from '@/components/liveCallMod'
import store from '@/store'
import { mapState } from 'vuex'
import VueSocketio from 'vue-socket.io'

export default {
  name: 'Main',
  components: {
    topBar,
    sidebar,
    featureContainer,
    liveCallMod,

  },
  computed: {
    ...mapState({
      hProduct: state => state.currentHproduct
    })
  },
  computed: {
    ...mapState({
      hProduct: state => state.currentHproduct
    })
  },
  data: function() {
    return {
      currentView: 'inbox',
      waveformsArray: [],
      callCenterAccount: false,
      mobileView: false,
      sideBarToggle: false,
      blockednumbers:[],
      timeout: null
    }
  },
  beforeMount: function () {
    var intHProduct = parseInt(this.hProduct);
    var CallCenterHproduct = [24];
    if (CallCenterHproduct.indexOf(intHProduct) !== -1) {
      this.NotcallCenterAccount = false;
    }
    else{
      this.NotcallCenterAccount = true;
    }
  },
  created: function () {
    var width = document.body.clientWidth;
    if (width < 769) {
      this.mobileView = true;
      this.sideBarToggle = true;
      window.addEventListener('resize', this.onResize);
      var vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      console.log('hello');
    }
  },
  methods: {
    onResize(event) {
     if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        var vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      }, 300)
    },
    addWaveForm: function (wavesurfer) {
      this.waveformsArray.push(this.wavesurfer)
    },
    updateView: function (view) {
      this.currentView = view
    },
    showHideSide: function () {
      if (this.sideBarToggle) {
        this.sideBarToggle = false
      }
      else{
        this.sideBarToggle = true
      }
    },
    addBlockedNumber:function(number){
      this.blockednumbers.push(number)
    }
  }
}
</script>